import React from 'react';

import UI from '../ui';
import Utils from '../utils';

const { WrappedButton, WrappedButtonType } = UI;
const { Navigation } = Utils;

const StoreHeader = props => {
	const onLastButtonClick = () => {
		// redirect user to store home page
		Navigation.navigateTo('storeHome');
	};

	return (
		<div className="common-header store-header">
			<WrappedButton
				label="&nbsp;" // no label text
				className="app-store-logo-button"
				buttonType={WrappedButtonType.TertiaryGrey}
				onClick={onLastButtonClick}
				dataqa="store-header-logo-button"
			/>
			<div className="simple-usps-logo" />
		</div>
	);
};

export default StoreHeader;
